var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPause = function SvgPause(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3 4c0-.7 0-1.05.136-1.317a1.25 1.25 0 0 1 .547-.547C3.95 2 4.3 2 5 2h1c.7 0 1.05 0 1.317.136.236.12.427.311.547.547C8 2.95 8 3.3 8 4v12c0 .7 0 1.05-.136 1.317a1.25 1.25 0 0 1-.547.547C7.05 18 6.7 18 6 18H5c-.7 0-1.05 0-1.317-.136a1.25 1.25 0 0 1-.547-.547C3 17.05 3 16.7 3 16zM12 4c0-.7 0-1.05.136-1.317a1.25 1.25 0 0 1 .547-.547C12.95 2 13.3 2 14 2h1c.7 0 1.05 0 1.317.136.236.12.427.311.547.547C17 2.95 17 3.3 17 4v12c0 .7 0 1.05-.136 1.317a1.25 1.25 0 0 1-.547.547C16.05 18 15.7 18 15 18h-1c-.7 0-1.05 0-1.318-.136a1.25 1.25 0 0 1-.546-.547C12 17.05 12 16.7 12 16z"
  })));
};
export default SvgPause;